export default "__VITE_ASSET__Bge8IeSM__"